import { createFileRoute } from '@tanstack/react-router';
import { PeopleWelcomeRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 *
 * Both People segments are served, and neither needs a `segment`: this URL only
 * ever redirects, to the account's canonical list URL or to the Ember twin.
 */
function ProfilesWelcomeRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleWelcomeRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profiles/welcome')({
  component: ProfilesWelcomeRoute,
});
